import { ErrorTracking } from '@common/errorTracking';

/**
 * Mixpanel tracking for Next.js
 * Do not use outside of the Next directory
 */
export const mixpanelTrackNext = (
  eventName: string,
  props: Record<string, unknown>,
): void => {
  try {
    if (window.mixpanel?.track) {
      window.mixpanel.track(eventName, props);
    }
  } catch (error) {
    ErrorTracking.track(error, { message: 'Mixpanel error' });
  }
};
